import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components/macro';
import AsyncStorage from '@react-native-community/async-storage';
import { Tooltip, Menu, MenuItem, Button, useTheme } from '@material-ui/core';
import { ArrowDropDown as IconArrowDropDown } from '@material-ui/icons';

import * as AppActions from '../../store/modules/app/app-actions';
import { AppStateType } from '../../store/modules/root-reducer';

import { ISA_LOCALE, LOCALES } from '../../constants';

const Flag = styled.img`
  width: 26px;
  height: 100%;
`;

const LanguagesDropdown: React.FunctionComponent<any> = React.memo(() => {
  const locale = useSelector((state: AppStateType) => state.app.locale);
  const dispatch = useDispatch();
  const theme = useTheme();

  const [anchorMenu, setAnchorMenu] = useState<any>(null);
  const [currentLocale, setCurrentLocale] = useState<any>(null);
  const [locales] = useState([
    {
      key: LOCALES.PORTUGUESE,
      title: 'Português',
      flag: '/static/img/flags/br.png'
    },
    {
      key: LOCALES.ENGLISH,
      title: 'Inglês',
      flag: '/static/img/flags/us.png'
    },
    {
      key: LOCALES.SPANISH,
      title: 'Espanhol',
      flag: '/static/img/flags/es.png'
    }
  ]);

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget);
  };

  const handleLocale = async (newLocale: any) => {
    if (locale !== newLocale?.key) setCurrentLocale(newLocale);

    await AsyncStorage.setItem(ISA_LOCALE, newLocale.key ?? LOCALES.PORTUGUESE);
    dispatch(AppActions.setLanguage(newLocale.key));
    closeMenu();
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  useEffect(() => {
    const current = locales.find(l => l.key === locale);

    setCurrentLocale(current);
  }, [locales, locale]);

  return (
    <>
      <Tooltip title="Languages">
        <Button
          aria-owns={Boolean(anchorMenu) ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          fullWidth
          color="inherit"
          variant="contained"
          style={{
            height: 44,
            display: 'flex',
            justifyContent: 'space-between',
            background: theme.palette.background.default
          }}
        >
          <Flag src={currentLocale?.flag} alt={currentLocale?.title} />
          <span style={{ marginLeft: 16 }}>{currentLocale?.title}</span>
          <IconArrowDropDown />
        </Button>
      </Tooltip>
      <Menu id="menu-appbar" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        {locales.map(locale => (
          <MenuItem key={locale.key} onClick={() => handleLocale(locale)}>
            <Flag src={locale.flag} alt={locale.title} /> <span style={{ marginLeft: 16 }}>{locale.title}</span>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});

export default LanguagesDropdown;
